export enum BuildResult {
  Failed = 'FAILURE',
  Success = 'SUCCESS',
  Pending = 'IN PROGRESS',
}

export enum BuildStatus {
  Started = 'STARTED',
  Created = 'CREATED',
  Completed = 'COMPLETED',
}

export interface BuildModel {
  apiLevel: number;
  marketingName: string;
  marketingVersion: string;
  branch: string;
  lunch: string;
  manifestName: string;
}

export interface DeviceBuildModel {
  internalName: string;
  arch: string;
  arch2: string;
  block?: boolean;
  builderSupported?: boolean;
  builds: BuildModel[];
  cpu_abi: string;
  cpu_abi2: string;
  createdAt: string;
  externalName: string;
  familyName: string;
  marketingName: string;
  maxMasonVersion: string;
  signingName: string;
  updatedAt: string;
}

export interface JobModel {
  configVersion: string;
  createdAt: string;
  customer: string;
  details?: string;
  device: string;
  id: string;
  lastUpdatedAt: number;
  product: string;
  project: string;
  result?: BuildResult;
  status?: BuildStatus;
  submittedAt: number;
  releaseType?: string;
}

export interface HardwareModel {
  devices: DeviceBuildModel[];
}

export interface JobsStatusModel {
  message: string;
  status: string;
  data: JobModel[];
}

export type GetHardwareOptions = unknown;

export interface GetJobsStatusOptions {
  customerId: string;
}

export interface GenerateDeviceReportOptions {
  email: string;
  customerId: string;
}

export interface GenerateDeviceReportResult {
  message: string;
  status: string;
  uuid: string;
}

export interface FamilyApiLevels {
  family: string;
  apiLevels: number[];
}
